var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-contact-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 2H3C1.897 2 1 2.897 1 4V17C1 18.103 1.897 19 3 19H5V22.5C5 22.702 5.1215 22.8845 5.3085 22.962C5.3705 22.9875 5.4355 23 5.5 23C5.63 23 5.758 22.949 5.8535 22.8535L9.707 19H21C22.103 19 23 18.103 23 17V4C23 2.897 22.103 2 21 2ZM22 17C22 17.5515 21.5515 18 21 18H9.5C9.367 18 9.24 18.0525 9.1465 18.1465L6 21.293V18.5C6 18.224 5.7765 18 5.5 18H3C2.4485 18 2 17.5515 2 17V4C2 3.4485 2.4485 3 3 3H21C21.5515 3 22 3.4485 22 4V17Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.848 10.3585C14.548 9.809 15 8.957 15 8C15 6.3455 13.6545 5 12 5C10.3455 5 9 6.3455 9 8C9 8.957 9.452 9.8085 10.152 10.3585C8.308 11.095 7 12.896 7 15V15.5C7 15.776 7.2235 16 7.5 16H16.5C16.7765 16 17 15.776 17 15.5V15C17 12.896 15.692 11.095 13.848 10.3585ZM10 8C10 6.897 10.897 6 12 6C13.103 6 14 6.897 14 8C14 9.103 13.103 10 12 10C10.897 10 10 9.103 10 8ZM8 15C8 12.7945 9.7945 11 12 11C14.2055 11 16 12.7945 16 15H8Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-contact-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.e8830a570f018e4ddadc3cbd4310fa1e.svg";
export { ForwardRef as ReactComponent };